import {Autoplay, Lazy, Navigation, Swiper} from "swiper";
Swiper.use([ Navigation, Autoplay, Lazy]);

const swiper = new Swiper(".testimonial-swiper", {
    loop: true,
    slidesPerView: 1,
    autoplay: {
        delay: 3000,
    },
    navigation: {
        nextEl: '.testimonial-swiper-button-next',
        prevEl: '.testimonial-swiper-button-prev',
    },
});
